"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGlobalState = exports.GlobalStateProvider = exports.StateContext = void 0;

var _tslib = require("tslib");

var _react = _interopRequireWildcard(require("react"));

var _savedAddresses = require("../savedAddresses");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}
/* istanbul ignore file */


var StateContext = (0, _react.createContext)({});
exports.StateContext = StateContext;
var localAppState = '@lce/local/api';

var GlobalStateProvider = function GlobalStateProvider(_a) {
  var children = _a.children,
      initialAppState = _a.initialState;
  var initialState = (0, _tslib.__assign)({}, initialAppState); // tslint:disable-next-line

  var provider = typeof window !== 'undefined' && window.localStorage; // this set State function needs some work... 🙃

  var _b = (0, _react.useState)(function () {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, JSON.parse(provider && provider.getItem(localAppState) || '{}')), initialState);
  }),
      state = _b[0],
      setState = _b[1];

  var _c = (0, _react.useState)(function () {
    return Object.keys((0, _tslib.__assign)((0, _tslib.__assign)({}, JSON.parse(provider && provider.getItem(localAppState) || '{}')), initialState));
  }),
      persistedKeys = _c[0],
      setPersistedKeys = _c[1];

  var updateStateByKey = (0, _react.useCallback)(function (key, persist) {
    if (persist === void 0) {
      persist = false;
    }

    return function (value) {
      var _a;

      setState((0, _tslib.__assign)((0, _tslib.__assign)({}, state), (_a = {}, _a[key] = value, _a)));
      !!persist && !!window && setPersistedKeys((0, _tslib.__spreadArrays)(persistedKeys, [key]));
    };
  }, []);
  (0, _react.useEffect)(function () {
    // build an object of key: value pairs from the persisted state keys
    var stateToPersist = persistedKeys.reduce(function (acc, next) {
      var _a;

      return (0, _tslib.__assign)((0, _tslib.__assign)({}, acc), (_a = {}, _a[next] = state[next], _a));
    }, {});
    provider && provider.setItem(localAppState, JSON.stringify(stateToPersist));
  }, [persistedKeys]);
  return initialState.settings ? _react["default"].createElement(StateContext.Provider, {
    value: {
      state: state,
      updateStateByKey: updateStateByKey
    }
  }, _react["default"].createElement(_savedAddresses.SavedAddressesProvider, null, children)) : null;
};

exports.GlobalStateProvider = GlobalStateProvider;

var useGlobalState = function useGlobalState(key, isAsync, persist) {
  if (isAsync === void 0) {
    isAsync = false;
  }

  if (persist === void 0) {
    persist = false;
  }

  if (isAsync) {
    // tslint:disable-next-line
    var provider = typeof window !== 'undefined' && window.localStorage;
    var storage = (0, _tslib.__assign)({}, JSON.parse(provider && provider.getItem(localAppState) || '{}'));
    return [storage && storage.hasOwnProperty(key) ? storage[key] : undefined, storage && storage.updateStateByKey && storage.updateStateByKey(key, persist)];
  } else {
    var context = (0, _react.useContext)(StateContext);
    return [context.state && context.state.hasOwnProperty(key) ? context.state[key] : undefined, context && context.updateStateByKey && context.updateStateByKey(key, persist)];
  }
};

exports.useGlobalState = useGlobalState;